import createApiServices from "./createApiServices"
import {BACKEND_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: BACKEND_URL})

export const getTenantParam = (userName, payload) => {
    return api.makeRequest({
        url: `/crm/getTenantParam?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getUserSale = (userName, payload) => {
    return api.makeRequest({
        url: `/crm/getUserSale?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getApParam2 = (payload) => {
    return api.makeRequest({
        url: `/crm/getApParamv2`,
        method: 'POST',
        data: payload
    })
}

export const getTenants = (payload, userName) => {
    return api.makeRequest({
        url: `/v1.0/base/getTenants?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}
